import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { StyledContactForm, StyledSuccess, StyledSuccessMessage, LocationSection, LocationTitle, LocationContainer } from './EmailBackToBackStyles';
import { FormSection, FormTitle } from '../Form/FormStyles';
import { GrValidate } from 'react-icons/gr'


export const EmailBackToBack = () => {
  const form = useRef();
  const [visibleForm, setVisibleForm] = useState(true);
  const [visibleSuccess, setVisibleSuccess] = useState(false);

 

  const sendEmail = (e) => {
    e.preventDefault();
    alert("Zahvaljujemo na poruci, čujemo se uskoro!");
    setVisibleForm(false);
    setVisibleSuccess(true);

    emailjs.sendForm('service_i3jqn2g', 'template_pccxgyv', form.current, 'gYajpj25UZNT0UxDo')
      .then((result) => {
          console.log(result.text);
          console.log("msg sent biiitc")
     
      }, (error) => {
          console.log(error.text);
      });
 
  };


  return (
    <><FormSection>
      {visibleForm && (<><StyledContactForm>
        <FormTitle>Kontakt</FormTitle>
        <form ref={form} onSubmit={sendEmail}>
          <label>Ime i prezime</label>
          <input type="text" name="user_name" required={true} />
          <label>Br telefona</label>
          <input type="text" name="user_number" required={true} />
          <label>Email</label>
          <input type="email" name="user_email" />
          <label>Vaša poruka</label>
          <textarea name="message" required={true} />
          <input type="submit" value="Pošalji" style={{ backgroundColor: "#060707" }} />
        </form></StyledContactForm></>)} {visibleSuccess && (<StyledSuccess style={{ color: "white" }}><GrValidate style={{ height: "100px", width: "100px" }} /><StyledSuccessMessage><h2>Zahvaljujemo na javljanju, uskoro ćemo vas kontaktirati!</h2></StyledSuccessMessage>
          <StyledSuccessMessage><h2>Thank you for contacting, you'll hear from us soon!</h2></StyledSuccessMessage></StyledSuccess>)}
    </FormSection>
    
    <LocationSection> 
    <LocationTitle>Kako do nas?</LocationTitle>
    
    <LocationContainer><iframe src="https://maps.google.com/maps?width=720&amp;height=600&amp;hl=en&amp;q=Ilica%2035,%20Zagreb,%2010000+(My%20Business%20Name)&amp;t=k&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></LocationContainer>
    </LocationSection></>
  );
};